import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerYoutubeAnalyticsPosts.graphql';
import { Query, QueryinfluencerYoutubeAnalyticsPostsArgs } from '../../__generated__/globalTypes';

export const useInfluencerYoutubeAnalyticsPostsQuery = (
  options?: QueryHookOptions<Query, QueryinfluencerYoutubeAnalyticsPostsArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerYoutubeAnalyticsPostsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerYoutubeAnalyticsPostsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerYoutubeAnalyticsPostsArgs>
): QueryResult<Query, QueryinfluencerYoutubeAnalyticsPostsArgs> & {
  getInfluencerYoutubeAnalyticsPosts: LazyQueryExecFunction<Query, QueryinfluencerYoutubeAnalyticsPostsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerYoutubeAnalyticsPosts, result] = useLazyQuery<Query, QueryinfluencerYoutubeAnalyticsPostsArgs>(
    QUERY,
    {
      onError: (error) => {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      },
      ...options
    }
  );

  return { getInfluencerYoutubeAnalyticsPosts, ...result };
};

export const useInfluencerYoutubeAnalyticsPostsPromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerYoutubeAnalyticsPosts = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerYoutubeAnalyticsPostsArgs, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerYoutubeAnalyticsPostsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerYoutubeAnalyticsPosts };
};
// Suspense Query Hooks
export const useInfluencerYoutubeAnalyticsPostsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerYoutubeAnalyticsPostsArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerYoutubeAnalyticsPostsArgs>(QUERY, {
    ...options
  });

  return result;
};
